import { API_BASE_API_SSO_URL } from '../urls';

export const API_SUBSCRIBE_EMAIL_CHECK = `${API_BASE_API_SSO_URL}/coming_soon/check`;
export const API_SUBSCRIBE_EMAIL_SEND = `${API_BASE_API_SSO_URL}/coming_soon/add`;
